import React from 'react';
import { StickyBar } from './components/StickyBar';
import { HeroSection } from './components/HeroSection';
import { PainPointsSection } from './components/PainPointsSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ProductSection } from './components/ProductSection';
import { BonusesSection } from './components/BonusesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white text-body-main selection:bg-[#C9A84C] selection:text-white flex flex-col" data-id="element-0">
      <StickyBar data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainPointsSection data-id="element-4" />
        <BenefitsSection data-id="element-5" />
        <PricingSection data-id="element-6" />
        <BonusesSection data-id="element-7" />
        <TestimonialsSection data-id="element-8" />
        <FAQSection data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}